import { defineStore } from 'pinia';

// 放量开关
export const useGenerousSwitchStore = defineStore('generousSwitch', {
  state: () => ({ switch: false }),
  actions: {
    setGenerousSwitch(generousSwitch: boolean) {
      this.switch = generousSwitch;
    },
  },
});
